<template>
 <div id="import_timestore_list">
   <div :class="`loader${loaderClass}`" v-show="loading"></div>
       <div id="page-content-wrapper" class="admin-content-area">
                <div class="page-name" >
                    <span class="page-title" id="pageHeader">Work Entry</span>
                    <button type="button" class="btn btn-primary pull-right" v-on:click.prevent="openModal('endShift')" >
                            End Shift
                    </button>
                </div>
                <template v-if="cantAccessPage === true">
                <div class="container-fluid">
                    <div class="admin-page-content time-store">
                       <section class="internal-container border-top-table-fl">
                           <div class="table-responsive-sm">
                              <table aria-describedby="table" class="table table-sm">
                                  <thead>
                                      <tr class="table-active">
                                          <th style="width:300px">Indirect  Labor  Code</th>
                                          <th style="width:50px"></th>
                                          <th style="width:400px">Work  Order</th>
                                          <th>Action</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr>
                                          <td>
                                              <v-select v-model="indirectLaborCode"
                                              name="wi_reason_id"
                                              placeholder="Select Indirect Labor Code." label="text"
                                              :options="indirectLaborCodeArr"
                                              :clearable="true">
                                              </v-select>
                                              <span class="text-danger">{{indirectLaborCodeError}}</span>
                                          </td>
                                          <td style="text-align: center; line-height: 2.5;">
                                          OR
                                          </td>
                                          <td>
                                              <v-select
                                                  v-model="workOrder"
                                                  name="work_order"
                                                  placeholder="Select Work Order."
                                                  label="work_order_no"
                                                  :options="workOrderArr"
                                                  @input="changedValueworkOrder()"
                                                  :filterable="true"
                                                  :clearable="true">
                                              </v-select>
                                              <span class="text-danger">{{workOrderError}}</span>
                                          </td>
                                          <td>
                                              <button type="button" class="btn btn-primary "
                                              v-on:click.prevent="openModal('start')">
                                                  <i class="fp-save"> </i> Start
                                              </button>
                                          </td>
                                        </tr>
                                </tbody>
                            </table>
                          </div>
                       </section>
                       <data-table-filter-config :moduleName="'workEntryList'" ref="filterWorkEntry" @cancelSelection="cancelAll"></data-table-filter-config>
                       <section class="data-table bg-white">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'workEntryList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        ref="listWorkEntry"
                                        mode="remote"
                                        title="Work Entry"
                                         @on-page-change="onPageChange"
                                         @on-per-page-change="onPerPageChange"
                                         @on-selected-rows-change="selectionChanged"
                                         :paginate="true"
                                        :totalRows="totalRecords"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginationOptions="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        >
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                              <template v-if="canUpdateEtk && props.row.duration != '-'">
                                                <template v-if="props.row.is_editable != undefined">
                                                  <template v-if="props.row.is_editable == 1">
                                                  <router-link  title="Edit Timelog" v-bind:key="'action' + key" class="fp-edit" v-bind:to="{name: 'EditTimeLog',params:{id: props.row.id}}"></router-link>
                                                  </template>
                                                </template>
                                              </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="canDeleteEtk && showDeleteBtn" id="deleteEtkLogBtn" v-on:click.prevent="timeLogDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
                </template>
                <template v-else-if="cantAccessPage === false">
                    <div class="container-fluid">
                      <div class="bg-white text-center">
                          <h1>
                              Oops!</h1>
                          <h2>
                              403 </h2>
                          <div class="error-details">
                              Sorry!, You don't have permission to access this page.
                          </div>
                      </div>
                  </div>
              </template>
              <template v-else>
                  <loading-content></loading-content>
              </template>
              <app-footer></app-footer>
       </div>
          <div class="modal fade invoice-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Are You {{first_name}} ?</h5>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="form-row">
                                <div class="col-md-8 form-group">
                                    <label class="control-label require" for="name">Please select technician:</label>
                                    <v-select v-model="serviceTaskLabor" autocomplete="nope" name="serviceTaskLabor" id="serviceTaskLabor" label="text" :filterable="true" :options="techArr" placeholder="Select Technician" class="close-remove">
                                        <!-- <template slot="no-options">
                                            Search Technician...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template> -->
                                    </v-select>
                                    <div class="field-error">{{ serviceTaskLabor_error_msg }}</div>
                                </div>
                                <div class="col-md-8 form-group">
                                    <label class="control-label require" for="name">Please enter your password:</label>
                                    <input autocomplete="nope" class="form-control" v-model="enteredPin" id="user_pin"
                                        name="user_pin" type="password" placeholder="Enter Password">
                                    <div class="field-error">{{error}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-tertiary" id="okbutton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                        <!-- <button type="button" class="btn btn-secondary" id="myButton" v-on:click="logout()"> <i class="fp-import"> </i> Logout</button> -->
                        <button type="button" class="btn btn-primary" id="myButton" v-on:click="checkUserPin()"> <i class="fp-save"> </i> Submit</button>
                    </div>
                </div>
            </div>
        </div>
 </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

import moment from 'moment';
var self;

export default {
   name: "TimeStore",
   metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Work Entry | " +process.env.COPYRIGHT_NAME
   },
    mixins: [commonMixins, contractMixins,dataTableMixins],
     data: () => ({
          workOrder : null,
          workOrderArr: [],
          loading:false,
          componentCategory:'',
          responseArray:'',
          indirectLaborCode:null,
          indirectLaborCodeArr:[],
          taskName: [],
          componentArr: [],
          userId : 0,
          first_name:'',
          indirectLaborCodeError : '',
          workOrderError : '',
          componentCategoryError : '',
          enteredPin:'',
          error:'',

        // workOrderTaskArr: [],

        userColumns:[],
        columns:[
          {
            label: 'Actions',
            field: 'action',
            sortable: false,
          },
          {
            label: 'User',
            field: 'user',
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            sortable: false,
          },
          {
            label: 'Work',
            field: 'work',
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            sortable: false,
          },
          {
            label: 'Start Time',
            field: 'start',
            filterable: true,
            sortable: false,
            fpFieldType:"date",
            hidden:false,
          },
          {
            label: 'End Time',
            field: 'end',
            filterable: true,
            sortable: false,
            fpFieldType:"date",
            hidden:false,
          },
          {
            label: 'Duration',
            field: 'duration',
            sortable: false,
            filterable: false,
            fpFieldType:"integer",
            hidden:false,
          },
          {
            label: 'Updated Duration',
            field: 'updated_duration',
            filterable: false,
            sortable: false,
            fpFieldType:"integer",
            hidden:false,
          },
          {
            label: 'Status',
            field: 'status',
            filterable: false,
            sortable: false,
            fpFieldType:"option",
            hidden:false,
          }
        ],

        rows: [],
        totalRecords: 0,
        firstLoad : 0,
        permissions:[],
        cantAccessPage:"",
        canUpdateEtk:false,
        eventPerformed:"",
        techArr: [],
        serviceTaskLabor:'',
        serviceTaskLabor_error_msg:'',
        locationId:'',
        canDeleteEtk:false,
        showDeleteBtn:false,
        requestInProgress: false,
     }),
     watch:{

        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'etk_list') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'etk_add') {
                    self.canUpdateEtk = true;
                }
                if (permissions.name == 'etk_delete') {
                    self.canDeleteEtk = true;
                }
            });
        },
    },
     beforeMount() {
      self = this;
     },
     mounted() {
      var userObj = JSON.parse(localStorage.getItem("user_obj"));
      if (userObj != null) {
        console.log(userObj.first_name);
        self.userId = userObj.id;
        self.first_name = userObj.first_name;
        self.locationId = userObj.location_id;
      }
      this.getPermissions();
      this.loadFieldData(['indirectlaborcode','technician'],self.locationId);
      this.loadLogData();

     },
     methods: {
        cancelAll: function (cancelAll) {
            this.$refs.listWorkEntry.unselectAllInternal();
        },

        onSearchTechnician(search, loading) {
            var self = this;
            if (search.length > 0) {

                loading(true);
                if (self.locationId != ''){
                    self.searchField(loading, search, 'technician', self.locationId);
                }else{
                    self.searchField(loading, search, 'technician', '');
                }
            }
        },

        // logout: function() {

        //     //call to remove cache for the logged in user
        //     $.ajax({
        //         url: process.env.ROOT_API + "/user/logout",
        //         type: "POST",
        //         headers: {
        //             "Accept": "application/json",
        //             "Authorization": "Bearer " + localStorage.getItem("tkn"),
        //             "Access-Control-Allow-Headers":
        //                 "Origin, Content-Type, Authorization,X-Requested-With",
        //             "Cache-Control": "no-cache"
        //         },
        //         dataType: "json",
        //         success: function (data) {
        //             self.loading = false;
        //             $('#myModal').modal('hide');
        //             localStorage.clear();
        //             var path = window.location.pathname;
        //             self.$router.push({ name: "Login", path: "/", params: { redirect_url: path } });
        //             self.$root.$emit('redirect_to_login');
        //         },
        //         error: function (jqXHR, exception) {
        //             self.loading = false;
        //             if (jqXHR.status == 0) {
        //                 self.errorMsg = "Remote server cannot be reached";
        //             } else {
        //                 //redirect to login page if user not authenticated
        //                 if (jqXHR.status == 401) {
        //                     //clear previous data


        //                 }
        //                 self.error = jqXHR.responseJSON.message;
        //             }
        //         }
        //     });

        // },

        EndShiftRequest: function() {

            if ( self.userId != 0 ) {
                if ( self.requestInProgress == true ) {
                    return;
                }
                self.requestInProgress = true;

                $.ajax({

                    url: process.env.ROOT_API + '/end-etklog',
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data:{
                        user_id: self.serviceTaskLabor.value
                    },

                    success: function(data) {
                        self.requestInProgress = false;
                        if (data.status == "success") {
                            self.$refs.filterWorkEntry.onColumnFilter('cancel');
                            self.loadList();
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.requestInProgress = false;
                        console.log("data == ", jqXHR);
                            self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
                        }
                    });
                }

        },
        loadList:function(){

         if(self.userId != 0) {
           var currentDate = moment().format("MM/DD/YYYY");
           var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                current_date:currentDate
            };
            self.loading = true;
            $.ajax({

                url: process.env.ROOT_API + "/get-etk/work_time_log",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,
                data:fields,

                success: function(data) {
                  //console.log("success");
                  self.loading = false;
                  //default date filter when page load
                  if (self.$refs.filterWorkEntry.etkDateFilter) {
                    self.$refs.filterWorkEntry.etkDateFilter = false;
                  }
                  if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                  }else{


                  }

                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
                }
            });
          }

       },
        checkLogEntry:function () {

            var checked = true;
            self.indirectLaborCodeError = '';
            self.workOrderError = '';
            self.componentCategoryError = '';

            if ( self.indirectLaborCode == null && self.workOrder == null ) {

                self.indirectLaborCodeError = "Please select labor code OR work order";
                checked = false;
            } else if ( self.indirectLaborCode != null && self.workOrder != null ) {
                self.indirectLaborCodeError = "Please select labor code OR work order";
                checked = false;
            }
            // if ( self.workOrder == null ) {
            //     self.workOrderError = "Please select work order line item"
            //     checked = false;
            // }

            return checked;

        },

        checkUserPin: function () {
            var self = this;
            var error = false;
            self.serviceTaskLabor_error_msg = '';
            //verfiy validation
            if ( self.eventPerformed == "start" ) {
                error = self.checkLogEntry()
            }
            if (self.serviceTaskLabor == null || !self.serviceTaskLabor.value){
                self.serviceTaskLabor_error_msg = 'Technician required';
                return;
            }
            //check event is endshif or start
            if ( error || self.eventPerformed == "endShift" ) {

                var dataField = {
                    user:self.serviceTaskLabor.value,
                    password : self.enteredPin
                };
                self.error = "";

                if ( self.requestInProgress == true ) {
                    return;
                }
                self.requestInProgress = true;

                $.ajax({
                    url: process.env.ROOT_API + "/user/verify-password",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data: dataField,

                    success: function(data) {
                        self.requestInProgress = false;
                        if ( data.code == 200 ) {

                            $('#myModal').modal('hide');
                            if ( self.eventPerformed == "endShift" ) {
                                self.EndShiftRequest();
                            } else {
                                self.startLog();
                            }

                        } else {
                            self.error = "Incorrect password."
                            self.enteredPin = "";
                        }
                    },
                    error: function(jqXHR, exception) {
                        //if user is logged out
                        self.requestInProgress = false;
                        if (jqXHR.status == 401) {
                            $('#myModal').modal('hide');
                            localStorage.clear();
                            var path = window.location.pathname;
                            self.$router.push({ name: "Login", path: "/", params: { redirect_url: path } });
                            self.$root.$emit('redirect_to_login');
                        }else{
                            self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
                        }
                    }
                });

            }

        },
        startLog: function () {

          if(self.checkLogEntry()) {
            console.log("workOrder =", self.workOrder);

            if(!self.indirectLaborCode) {

              var dataField = {
                user_id: self.serviceTaskLabor.value,
                work_order_items_id: self.workOrder.id

              }
             // console.log(dataField);
            } else {
              // labor code
              var dataField = {
                user_id: self.serviceTaskLabor.value,
                indirect_labor_code_id: self.indirectLaborCode.value

              }
              console.log("indirect_labor_code_id =", self.indirectLaborCode.value);
             // console.log(dataField);
            }
            if ( self.requestInProgress == true ) {
                return;
            }
            self.requestInProgress = true;
             $.ajax({

                url: process.env.ROOT_API + "/add-etklog",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,
                data: dataField,

                success: function(data) {
                  console.log("ADD LOG = ", data);
                  if (data.status == "success") {
                    self.requestInProgress = false;
                    self.indirectLaborCode = null;
                    self.componentCategory = '';
                    self.workOrder = null;
                    self.taskName = '';
                    self.$refs.filterWorkEntry.onColumnFilter('cancel');
                    self.loadList();
                  }else{
                    //if work order line item is already closed
                    if (data.code == 201) {
                        self.$swal('',data.message,'info');
                    }
                  }
                },
                error: function(jqXHR, exception) {
                    self.requestInProgress = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
                }
            });
          }


        },
        changedValueworkOrder: function () {
          console.log(self.workOrder);
          if(self.workOrder != null) {
            self.componentArr = self.workOrder.line_items;
          } else {
            self.componentArr = [];
            self.componentCategory = '';
            self.taskName = '';
          }

          // this.taskName = self.componentCategory.task;
        },
        changedValueComponent: function () {
          if(self.componentCategory != null) {
            this.taskName = self.componentCategory.task;
          } else {
            self.taskName = '';
          }
        },
        onSearchVMRS(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'vmrs', '');
            }
        },
        loadLogData: function(){
          if(self.userId != 0) {
            $.ajax({

                url: process.env.ROOT_API + "/get-etklog",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,
                data:{
                   user_id: self.userId


                },

                success: function(data) {
                  // console.log("MY DATA", data.length);
                  self.workOrderArr = data;
                  console.log("MY DATA", data.content);

                    // if (data.length > 0) {
                    //  // console.log("11111");
                    //  this.componentArr = [];

                    //     // console.log("data111111");
                    // }
                },
                error: function(jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
                }
            });
          }

        },
        openModal: function(flag){
            var self = this;
            self.enteredPin = "";

            if ( flag == "start" ) {

                self.eventPerformed = flag;
                self.serviceTaskLabor = '';
                self.enteredPin = '';
                self.serviceTaskLabor_error_msg = '';
                if ( self.checkLogEntry() ) {

                    $("#typeImage").val('');
                    $('#myModal').modal('show');
                }

            } else {

                self.eventPerformed = flag;
                $('#myModal').modal('show');
            }

        },
        selectionChanged(param) {
            var self = this;
            var rowData = self.$refs['listWorkEntry'].selectedRows;
            var editableArr = [];
            self.showDeleteBtn = false;
            if ( rowData.length > 0){
                for(var i = 0; i < rowData.length; i++){
                    if (rowData[i].is_editable != undefined && rowData[i].is_editable != null) {
                        if (rowData[i].is_editable == 1) {
                            editableArr.push("y");
                        }else{
                            if (rowData[i].log_done != undefined && rowData[i].log_done != null) {
                                if (rowData[i].log_done == 0) {
                                    editableArr.push("y");
                                }else{
                                    editableArr.push("n");
                                }
                            }else{
                                editableArr.push("n");
                            }
                        }
                    }
                }
            }
            //check all values in array are equal or not
            const allEqual = arr => arr.every( v => v === arr[0] );
            var found = allEqual(editableArr);

            if (found) {
                if (editableArr[0] == "y") {
                    self.showDeleteBtn = true;
                }
            }
        },
        timeLogDelete() {
            var self = this;
            self.$swal({
                title: 'Are you sure that you want to delete this Work Entry?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    var data = this.$refs['listWorkEntry'].selectedRows;
                    var use = [];
                    for (var i = 0; i < data.length; i++) {
                        use.push(this.$refs['listWorkEntry'].selectedRows[i].id)
                    }
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/etk/delete",
                        type: "POST",
                        data:{
                            id:use
                        },
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            if (data.status == 'success') {
                                var msg = "";
                                msg = data.content+" records have been deleted";
                                self.$swal('',msg,data.status);
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'delete-etk')
                        }
                    });
                } else {

                }
            });
        }


     },

}
</script>



// WEBPACK FOOTER //
// src/components/WorkEntry/TimeStore.vue